import { combineReducers } from 'redux';
import permissions from './permission.reducer';

const permissionAppReducer = combineReducers({
    permissions,
});

export default permissionAppReducer;


// WEBPACK FOOTER //
// src/main/content/permission/store/reducers/index.js